import { createSlice } from "@reduxjs/toolkit";
import {
  getCountries,
  getCountriesStates,
  addSingleState,
  addSingleCity,
} from "./locationActions";

const initialState = {
  countries: null,
  states: null,
  loading: false,
  error: null,
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    resetError(state) {
      state.error = null;
    },
    resetAddStateStatus(state) {
      state.addStateStatus = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle getCountries
      .addCase(getCountries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCountries.fulfilled, (state, action) => {
        state.loading = false;
        state.countries = action.payload;
      })
      .addCase(getCountries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Handle getCountriesStates
      .addCase(getCountriesStates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCountriesStates.fulfilled, (state, action) => {
        state.loading = false;
        state.states = action.payload;
      })
      .addCase(getCountriesStates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addSingleState.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addSingleState.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addSingleState.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addSingleCity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addSingleCity.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addSingleCity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError, resetAddStateStatus } = locationSlice.actions;

export default locationSlice.reducer;
